// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-editor-page-header {
  width: 100%;
}
.user-editor-page-header .page-header {
  margin: 0 auto;
}
.user-editor-page-header .left-offset {
  margin-left: 10px;
}`, "",{"version":3,"sources":["webpack://./Source/app/user/user-edit/user-edit-new-layout/user-editor-page-header/user-editor-page-header.component.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;AACJ;AAAI;EACI,cAAA;AAER;AAAI;EACI,iBAAA;AAER","sourcesContent":[".user-editor-page-header {\r\n    width: 100%;\r\n    .page-header {\r\n        margin: 0 auto;\r\n    }\r\n    .left-offset {\r\n        margin-left: 10px;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
